import { pushDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import {
    CategoryRecommendedProductAPIParameter,
    getCategoryRecommendedProduct,
} from "@NA/Services/ADICategoryRecommendedProductService";
import {
    RecommendedProductAPIParameter,
    RecommendedProductModel,
    getRecommendedProduct,
} from "@NA/Services/ADIRecommendedProduct";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";

type HandlerType = CustomApiHandler<CategoryRecommendedProductAPIParameter & HasOnSuccess, RecommendedProductModel>;

export const DispatchBeginLoadCategoryRecommendedProducts: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadCategoryRecommendedProducts",
        parameter: props.parameter,
    });
};

export const setCategoryRecommendedProduct: HandlerType = async (props: any) => {
    props.result = await getCategoryRecommendedProduct({
        scenario: props.parameter.scenario,
        modeling: props.parameter.modeling,
        userId: props.parameter.userId,
        erpNumber: props.parameter.erpNumber,
        categoryName: props.parameter.categoryName,
    });
    props.products = props.result.result.products;
    if (!props.result) {
        return false;
    }
};

export const MapProducts: HandlerType = (props: any) => {
    props.productInfosByProductId = {};
    props.products?.forEach((o: any) => {
        props.productInfosByProductId[o.id] = {
            productId: o.id,
            qtyOrdered: o.qtyOrdered,
            unitOfMeasure: o.unitOfMeasure,
            productDetailPath: o.productUri,
        };
    });
};

export const LoadRealTimePrices: HandlerType = async (props: any) => {
    const { products, productInfosByProductId } = props;
    if (!products?.length) {
        props.pricingLoaded = true;
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: products?.map((o: any) => ({
                productId: o.id,
                unitOfMeasure: o.unitOfMeasure,
                qtyOrdered: o.qtyOrdered,
            })),
            onComplete: realTimePricingProps => {
                if (realTimePricingProps?.apiResult) {
                    realTimePricingProps.apiResult.realTimePricingResults?.forEach(pricing => {
                        for (const productId in productInfosByProductId) {
                            const productInfo = productInfosByProductId[productId]!;
                            if (
                                productInfo.productId === pricing.productId &&
                                productInfo.unitOfMeasure === pricing.unitOfMeasure
                            ) {
                                productInfo.pricing = pricing;
                            }
                        }
                    });
                } else if (realTimePricingProps.error) {
                    for (const productId in productInfosByProductId) {
                        productInfosByProductId[productId]!.failedToLoadPricing = true;
                    }
                }
                props.pricingLoaded = true;
                props.realTimePricing = realTimePricingProps;
                SendTrackingCustom(props) 
            },
        }),
    );

    await waitFor(() => !!props.pricingLoaded);
};

export const LoadRealTimeInventory: HandlerType = (props: any) => {
    const { products, productInfosByProductId } = props;
    if (!products?.length || true) {
        props.inventoryLoaded = true;
        props.parameter.onSuccess(props);
        return;
    }

    // const { isAuthenticated } = props.getState().context.session;

    // const productIdsIds = Object.keys(productInfosByProductId);
    // if (isAuthenticated) {
    //     props.dispatch(
    //         loadRealTimeInventory({
    //             productIds: productIdsIds.map(o => productInfosByProductId[o]!.productId),
    //             onComplete: realTimeInventoryProps => {
    //                 if (realTimeInventoryProps?.error) {
    //                     productIdsIds.forEach(o => {
    //                         const productInfo = productInfosByProductId[o]!;
    //                         if (productInfo) {
    //                             productInfo.failedToLoadInventory = true;
    //                         }
    //                     });
    //                 } else {
    //                     realTimeInventoryProps?.apiResult?.realTimeInventoryResults?.forEach(inventory => {
    //                         productIdsIds.forEach(o => {
    //                             const productInfo = productInfosByProductId[o]!;
    //                             if (productInfo.productId === inventory.productId) {
    //                                 productInfo.inventory = inventory;
    //                             }
    //                         });
    //                     });
    //                 }

    //                 props.inventoryLoaded = true;
    //             },
    //         }),
    //     );
    // }
    // else {
    //     props.inventoryLoaded = true;
    // }

    // props.parameter.onSuccess(props);
};

export const DispatchCompleteLoadCategoryRecommendedProducts: HandlerType = (props: any) => {
    if (props) {
        props.dispatch({
            type: "Custom/CompleteLoadCategoryRecommendedProducts",
            recommendedProduct: props.products,
        });
    }
};

export const SendTrackingCustom: HandlerType = (props: any) => {
    if (props.products?.length > 0) {
        const itemListName =
            props.products[0].properties["provider"] !== undefined &&
            props.products[0].properties["provider"] === "MSDRS"
                ? "MSDRS"
                : "Insite";
        pushDataToDataLayer(props.products, `Recommended Products: ${itemListName}`, props.getState().context.session, props.realTimePricing.apiResult);
    }
};

export const chain = [
    DispatchBeginLoadCategoryRecommendedProducts,
    setCategoryRecommendedProduct,
    MapProducts,
    LoadRealTimePrices,
    LoadRealTimeInventory,
    DispatchCompleteLoadCategoryRecommendedProducts
    
];

const categoryRecommendedProduct = createHandlerChainRunner(chain, "CategoryRecommendedProduct");
export default categoryRecommendedProduct;
